const EVENT_NAME = 'expressCheckout:error';

function dispatchExpressErrorEvent<T>(detail: T): void {
    const event = new CustomEvent<T>(EVENT_NAME, { detail });
    window.dispatchEvent(event);
}

export default dispatchExpressErrorEvent;
